import { IBreadcrumb } from '../../types/breadcrumbs';
import { IApplicationState } from '../../types/redux';

export const selectBreadcrumbs = (state: IApplicationState): IBreadcrumb[] | undefined => {
  return state.breadcrumbs;
};
